import { Factory, MapPin, Clock, Link2, Wifi, WifiOff, User } from "lucide-react";
import { STATUS_TINT, STATUS_LABEL } from "@/lib/mapTheme";
import { describeTruck, fmtMins, agoLabel } from "./fleetUtils";

export function FleetTruckRow({ t, selected, onSelect }) {
  const d = describeTruck(t);
  const tint = STATUS_TINT[t.status] || "#F97316";
  const mins = d.etaMins;
  const running = d.running;
  return (
    <button type="button" onClick={() => onSelect(t.id)} data-testid={`ctr-truck-row-${t.number}`}
      className={`w-full text-left bg-[#12151A] border transition-colors px-3 py-3 ${selected ? "border-[#38BDF8]" : "border-[#22262E] hover:border-[#3A404A]"}`}>
      <div className="flex items-start gap-3">
        <div className="w-1 self-stretch shrink-0" style={{ background: tint }} />
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-2 min-w-0">
              <span className="heading font-black text-base text-white" data-testid={`ctr-truck-number-${t.number}`}>{t.number}</span>
              <span className="mono text-[10px] text-[#8B909A]">{t.rego}</span>
              <span className="mono text-[9px] uppercase tracking-wider px-1.5 py-0.5 border" style={{ color: tint, borderColor: `${tint}66` }} data-testid={`ctr-truck-status-${t.number}`}>
                {STATUS_LABEL[t.status] || t.status}
              </span>
            </div>
            <span className={`inline-flex items-center gap-1 mono text-[9px] ${t.gps_dark ? "text-red-400" : "text-[#8B909A]"}`} title="Last GPS ping">
              {t.gps_dark ? <WifiOff className="w-3 h-3" /> : <Wifi className="w-3 h-3" />}{agoLabel(t.location_updated_at)}
            </span>
          </div>
          <div className="mt-1.5 text-sm text-[#E5E7EB] truncate" data-testid={`ctr-truck-headline-${t.number}`}>{d.headline}</div>
          <div className="mt-1 grid grid-cols-[1fr_auto] gap-2 items-end">
            <div className="text-[11px] text-[#8B909A] space-y-0.5 min-w-0">
              <div className="flex items-center gap-1.5 truncate"><Factory className="w-3 h-3 shrink-0 text-[#F97316]" /><span className="truncate" data-testid={`ctr-truck-plant-${t.number}`}>{t.plant?.name || t.org?.name || "—"}</span></div>
              <div className="flex items-center gap-1.5 truncate"><MapPin className="w-3 h-3 shrink-0 text-[#A855F7]" /><span className="truncate" data-testid={`ctr-truck-site-${t.number}`}>{t.job ? (t.job.site_name || t.job.site_address) : "No active job"}</span></div>
              <div className="flex items-center gap-1.5 truncate"><User className="w-3 h-3 shrink-0" /><span className="truncate">{t.driver_name || "Unassigned"}</span>{t.job?.mix_code && <span className="mono text-[#38BDF8]">· {t.job.mix_code} · {t.job.load_m3} m³</span>}</div>
            </div>
            <div className="text-right shrink-0">
              {d.eta ? (
                <>
                  <div className="text-[9px] tracking-widest uppercase text-[#8B909A] flex items-center gap-1 justify-end"><Clock className="w-3 h-3" />{d.etaLabel}</div>
                  <div className="heading font-black text-lg leading-none text-white mono" data-testid={`ctr-truck-eta-${t.number}`}>{d.eta}</div>
                  <div className={`mono text-[10px] ${running ? "text-emerald-400" : "text-[#8B909A]"}`}>{mins != null ? fmtMins(mins) : ""}{running ? " · live" : ""}</div>
                </>
              ) : (
                <div className="mono text-[10px] text-[#8B909A]">{t.today.loads} load{t.today.loads === 1 ? "" : "s"} · {t.today.m3} m³ today</div>
              )}
            </div>
          </div>
          <div className="mt-1.5 flex items-center gap-1 text-[9px] mono uppercase tracking-wider text-[#6B717C]"><Link2 className="w-3 h-3" />{t.link_source === "manual" ? "Linked by plant" : "Matched by rego"}</div>
        </div>
      </div>
    </button>
  );
}
